import { PRODUCT_SELECT, type ProductMultiSelectProps } from '../constants/product-select'
import { useProductMultiSelect } from '../hooks/useProductMultiSelect'
import '../styles/product-multi-select.scss'

export function ProductMultiSelect({
  products,
  selectedIds,
  disabled = false,
  onChange,
}: ProductMultiSelectProps) {
  const {
    query,
    setQuery,
    visible,
    selectedProducts,
    allVisibleSelected,
    toggle,
    selectVisible,
    clearSelection,
  } = useProductMultiSelect(products, selectedIds, onChange)

  return (
    <div className="product-multi-select">
      <div className="product-multi-select__toolbar">
        <label className="form-field product-multi-select__search">
          <span className="form-field__label">
            {PRODUCT_SELECT.label} <em>*</em>
          </span>
          <input
            type="search"
            value={query}
            onChange={(event) => setQuery(event.target.value)}
            placeholder={PRODUCT_SELECT.searchPlaceholder}
            disabled={disabled || products.length === 0}
          />
        </label>
        <div className="product-multi-select__actions">
          <button
            type="button"
            className="btn btn--ghost btn--sm"
            disabled={disabled || visible.length === 0 || allVisibleSelected}
            onClick={selectVisible}
          >
            {PRODUCT_SELECT.selectAll}
          </button>
          <button
            type="button"
            className="btn btn--ghost btn--sm"
            disabled={disabled || selectedIds.length === 0}
            onClick={clearSelection}
          >
            {PRODUCT_SELECT.clear}
          </button>
        </div>
      </div>

      <div className="product-multi-select__list" role="listbox" aria-multiselectable="true">
        {products.length === 0 ? (
          <p className="product-multi-select__empty">{PRODUCT_SELECT.empty}</p>
        ) : visible.length === 0 ? (
          <p className="product-multi-select__empty">{PRODUCT_SELECT.noMatches}</p>
        ) : (
          visible.map((product) => {
            const checked = selectedIds.includes(product.id)
            return (
              <label
                key={product.id}
                className={`product-multi-select__option${checked ? ' product-multi-select__option--on' : ''}`}
              >
                <input
                  type="checkbox"
                  checked={checked}
                  disabled={disabled}
                  onChange={() => toggle(product.id)}
                />
                <span>{product.name}</span>
              </label>
            )
          })
        )}
      </div>

      {selectedProducts.length ? (
        <div className="product-multi-select__selected">
          <p className="product-multi-select__count">
            {PRODUCT_SELECT.selectedCount(selectedProducts.length)}
          </p>
          <div className="product-multi-select__chips">
            {selectedProducts.map((product) => (
              <button
                key={product.id}
                type="button"
                className="product-multi-select__chip"
                disabled={disabled}
                onClick={() => toggle(product.id)}
                aria-label={`${PRODUCT_SELECT.remove} ${product.name}`}
              >
                <span className="product-multi-select__chip-name">
                  {product.name}
                </span>
                <span aria-hidden="true">×</span>
              </button>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  )
}
